import { style } from 'typestyle'
export const pt4 = style({ paddingTop: '4px' })
